import { render, staticRenderFns } from "./restaurantmanual.vue?vue&type=template&id=71dc41a2"
import script from "./restaurantmanual.vue?vue&type=script&lang=ts"
export * from "./restaurantmanual.vue?vue&type=script&lang=ts"
import style0 from "./restaurantmanual.vue?vue&type=style&index=0&id=71dc41a2&prod&lang=scss"
import style1 from "./restaurantmanual.vue?vue&type=style&index=1&id=71dc41a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports